import PropTypes from 'prop-types'
import React from 'react'

import DynamicImage from 'components/DynamicImage'
import RenderInView from 'components/RenderInView'
import { GOODS_TYPES } from 'constants/sales'
import { LocalizationContext } from 'contexts/Localization'

import {
  Bar,
  BarWrapper,
  ChartWrapper,
  ImageWrapper,
  TextStyled,
  Wrapper,
} from './styles'

const { wgs, dna } = GOODS_TYPES

const Indicator = React.forwardRef((props, ref) => {
  const { paths } = React.useContext(LocalizationContext)
  const { text, type, barWidth } = props
  const images = {
    [dna]: 'dna-left-new',
    [wgs]: 'wgs-left-new',
  }
  const imgName = type === dna ? images[dna] : images[wgs]
  const imageRef = React.useRef()
  const textRef = React.useRef()
  const barRef = React.useRef()

  React.useImperativeHandle(ref, () => ({ textRef, barRef, imageRef }))
  const [barText, setBarText] = React.useState(text)

  React.useEffect(() => {
    let timer
    if (text !== barText) {
      timer = setTimeout(() => setBarText(text), 300)
    }

    return () => clearTimeout(timer)
  }, [text, barText])

  return (
    <Wrapper {...{ type }}>
      <ChartWrapper>
        <ImageWrapper ref={imageRef}>
          <RenderInView>
            <DynamicImage
              alt={`box-${imgName}`}
              imageSizes={{
                md: 130,
              }}
              imageType="png"
              image={`${paths.cdn_boxes}/${imgName}`}
              namesByBreakpoints
            />
          </RenderInView>
        </ImageWrapper>
        <BarWrapper>
          <Bar {...{ barWidth }} isGray={type === dna} ref={barRef} />

          <TextStyled
            dangerouslySetInnerHTML={{
              __html: barText,
            }}
            ref={textRef}
          />
        </BarWrapper>
      </ChartWrapper>
    </Wrapper>
  )
})

Indicator.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf([wgs, dna]).isRequired,
  barWidth: PropTypes.number.isRequired,
}

export default Indicator
